import React from 'react';

import {Grid, List, Typography} from '@material-ui/core';

import { FuneralHome } from '../../../static/models/FuneralHome';
import { SearchLocation } from '../../../static/models/SearchLocation';
import Settings from '../../../static/models/Settings';
import LoadingLines from '../layout-components/loading-lines/loading-lines';
import ProviderListItem from '../provider-list-item/ProviderListItem';

const ProviderList: React.FunctionComponent<PropShape> = props => {
    if (props.isLoading) {
        return <LoadingLines />;
    }

    if (props.locations.length === 0 && props.searchLocation !== null) {
        return <Typography variant="subtitle1">Sorry, but there are no eFuneral providers near you.  Try to broaden your search radius.</Typography>;
    }

    if (props.selectedLocation) {
        const element = document.getElementById(props.selectedLocation.id + "-" + props.selectedLocation.name + "-account-card");
        element?.scrollIntoView({ behavior: 'smooth' });
    }

    if (props.locations.length > 0)
    {
        return (
            <Grid container direction="column" spacing={2}>
                <Grid item>
                    <Typography variant="subtitle2">
                        There are {props.locations.length} eFuneral provider locations near you.  Please select a location below to start planning online now.
                    </Typography>
                </Grid>

                <Grid item>
                    <List>

                        {props.locations.map((location, i) => (
                            <ProviderListItem
                                key={i}
                                location={location}
                                searchLocation={props.searchLocation}
                                settings={props.settings}
                                referralAccountIdentifier={props.referralAccountIdentifier}
                                selectedLocation={props.selectedLocation}
                                setSelectedLocation={props.setSelectedLocation}
                            />

                        ))}
                    </List>
                </Grid>
            </Grid>
        );
    }

    return <Typography variant="subtitle1">Find an eFuneral partner provider near you and start planning from the comfort of your home. To start, enter either a city and state, or a zip code to start a search.</Typography>;

};

interface PropShape {
    isLoading: boolean;
    locations: FuneralHome[];
    searchLocation: SearchLocation | null;
    settings: Settings;
    referralAccountIdentifier: string | null;
    selectedLocation: FuneralHome | undefined;
    setSelectedLocation: (location: FuneralHome | undefined) => void;
}

ProviderList.defaultProps = {
    // Set default values for props
    isLoading: true,
    locations: [],
    searchLocation: null,
    referralAccountIdentifier: null,
};

export default ProviderList;
